import React from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'
import CreateUserLearningAssignmentsForm from '../../components/learningAssignmentForms/CreateUserLearningAssignmentsForm/CreateUserLearningAssignmentsForm'
import useRoutes from '../../state/useRoutes'

export default React.memo(function AddLearningItemsToUserPage() {
  const { uuid } = useParams()
  const { close } = useOutletContext<any>()
  const { pathsOrCourses } = useParams()

  return (
    <CreateUserLearningAssignmentsForm userUuids={[uuid!]} onClose={close} pathsOrCourses={pathsOrCourses === '1'} />
  )
})

export function AddLearningItemsToUserPageBreadcrumb() {
  const { uuid } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return (
    <Link to={routes.addLearningItemsToUser.url({ uuid: uuid!, pathsOrCourses: null })}>
      {t('manage learning.add learning items')}
    </Link>
  )
}
